import { OrganizationResponse } from 'sync/organization-service';
import { TrialResponse } from 'sync/trial-service/trial-service.types';
import { OrganizationRecord } from './use-organization-list.types';

export const getOrganizationRecords = (
  trialsByOrganizationIdentifier: { [key: string]: TrialResponse },
  organizationsById: { [key: string]: OrganizationResponse }
) => {
  return Object.fromEntries(
    Object.entries(organizationsById).map(([organizationId, organization]) => {
      const trial = trialsByOrganizationIdentifier[organizationId];

      const organizationRecord: OrganizationRecord = {
        organizationId: organization.data.id,
        organization,
        trial: trial!,
      };

      return [organizationId, organizationRecord];
    })
  );
};
